import { NavLink } from "react-router-dom";
import { DesktopNav } from "./DesktopNav.styled";
import data from "assets/data/data.json";

data.routes.reverse();


function DesktopNavmenu() {
  return (
    <DesktopNav>
      <ul>
      {data.routes.map((route, idx) => {
          const routeClassName = route.name.split(" ").join("-").toLowerCase();
          return <li key={idx}><NavLink to={route.path} className={routeClassName}>{route.name}</NavLink></li>;
        })}
      </ul>
    </DesktopNav>
  );
}

export default DesktopNavmenu;
